var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmClockStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "Alarm-Clock--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Alarm Clock Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alarm-clock--time-tock-stopwatch-measure-clock-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.5967857142857144 2.8920713142857144C1.4027448214285716 1.9558816285714287 2.375624892857143 1.177584732857143 3.4658927142857148 0.5967857142857144",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.355 16.11321428571429c4.201371428571429 0 6.564642857142858 -2.3632714285714287 6.564642857142858 -6.564642857142858S12.55637142857143 2.9839285714285717 8.355 2.9839285714285717 1.7903571428571432 5.347200000000001 1.7903571428571432 9.54857142857143s2.3632714285714287 6.564642857142858 6.564642857142858 6.564642857142858Z",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.11321428571429 2.8920713142857144C15.307195500000002 1.9558816285714287 14.334434785714288 1.177584732857143 13.244107285714287 0.5967857142857144",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.355 5.967857142857143v3.5993578714285723l2.188055142857143 2.2354638000000002",
    strokeWidth: 1.29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClockStreamlineFlex);
export default __webpack_public_path__ + "static/media/Alarm-Clock--Streamline-Flex.0aa7eafb60ec20ef074107525aa349e8.svg";
export { ForwardRef as ReactComponent };